var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-navbar grid grid__base", class: _vm.bemFacets },
    [
      _c("div", { staticClass: "grid--container grid--container__fluid" }, [
        _c("div", { staticClass: "mobile-navbar--row grid--row" }, [
          _c(
            "a",
            {
              staticClass: "u-reset grid--col mobile-navbar--brand-link",
              attrs: { href: "/" }
            },
            [_vm._t("brand-logo")],
            2
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "u-reset hamburger hamburger--spin",
              class: _vm.buttonClasses,
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.$emit("toggle")
                }
              }
            },
            [_vm._m(0)]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "hamburger-box" }, [
      _c("span", { staticClass: "hamburger-inner" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a020a514", { render: render, staticRenderFns: staticRenderFns })
  }
}